import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import LoopIcon from '@material-ui/icons/Loop';
import headerImage from 'assets/processing.jpg';
import { Grid, Button } from '@material-ui/core';
import DB from '../db';
import { sendGetRequest, sendPostRequest, sendPutRequest, sendDownloadRequest } from 'utils/api';




const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    margin: 5,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

function ForProcessing() {
  
  const [famasDb, setFamasDb] = useState({
    db: new DB(),
    famas: {}
  });

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [itemsForProcessing, setItemsForProcessing] = React.useState([]);

  const handleExpandClick = (p_assetTag) => {
    
    let newObject = JSON.parse(JSON.stringify(p_assetTag));

    newObject.expanded = !newObject.expanded;

    const updatedObjects = itemsForProcessing.map((item) =>
      item.assetTag === p_assetTag.assetTag ? newObject : item
    );

    setItemsForProcessing(updatedObjects)
    //setExpanded(!expanded);

  };

  const getAllItems = async () =>{
    
    let res = await famasDb.db.getAllForProcessing();
    let items = Object.values(res);

    let newItems = [];

    for(let item of items){
      item.expanded = false;
      newItems.push(item);
    }

  
    setItemsForProcessing(newItems);
    console.log("FOR PROCESSING", items);
    
        
  }

  useEffect(() => {
    
    getAllItems();

    return () => {
    
    }
  }, []);

  const pushItem = async (p_item) =>{
    
    const dataToPush = {
      assetTag: p_item.assetTag,
      assetdesc: p_item.assetDesc,
      measure: p_item.uom,
      serno: p_item.serialNo,
      status: p_item.offlineAction,
      accost: p_item.acqCost,
      acdate: p_item.acqDate,
      coverage: 'Test',
      remark:  p_item.remarks,
      busunit: p_item.businessUnit,
      location: p_item.plantSite,
      dept:  p_item.department,
      touser: p_item.toUser,
      docno: p_item.docNo,
    }

    let pushRequest = await sendPostRequest(`/integration/export`, dataToPush);

    if(pushRequest.data){

      // let res = await famasDb.db.deletForProcessing(p_item);
      // if(res.ok){
      //   alert("FAMAS ITEM submitted to server.");
      //   getAllItems();
      // }
    }

    
  }

  const cancelItem = async (p_item) =>{

    let res = await famasDb.db.deletForProcessing(p_item);
    if(res.ok){
      alert("Deleted");
      getAllItems();
    }
  }

  const genKey = () => {
		const pre = Math.random().toString(36).substr(2, 5);
		return pre + new Date().getTime();
	}

  return (
    <React.Fragment>
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
    >
        
      
    {
      itemsForProcessing.map((item, index)=>{

        if(item.assetTag && item.assetDesc){

          return(
            <Grid key={`${genKey()}_item_for_processing_${index}`} item xs={12} md={4}>
            <Card className={classes.root}>
              <CardHeader
                avatar={
                  <Avatar aria-label="recipe" className={classes.avatar}>
                    F
                  </Avatar>
                }
                title="For Processing"
                subheader={item.createdAt}
              />
              <CardMedia
                className={classes.media}
                image={headerImage}
                title="For Processing"
              />
              <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                  {item.assetTag}
                </Typography>
              </CardContent>
              <CardActions disableSpacing>
                <IconButton aria-label="share" onClick={()=>pushItem(item)}>
                  <LoopIcon />
                </IconButton>
                <IconButton
                  className={clsx(classes.expand, {
                    [classes.expandOpen]: item.expanded,
                  })}
                  onClick={()=>handleExpandClick(item)}
                  aria-expanded={item.expanded}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                </IconButton>
              </CardActions>
                <Collapse in={item.expanded} timeout="auto" unmountOnExit>
                  <CardContent>
                    
                    <Typography paragraph>Asset Description:</Typography>
                    <Typography paragraph>
                        {item.assetDesc}
                    </Typography>
                    
                    <Typography paragraph>Asset Tag:</Typography>
                    <Typography paragraph>
                        {item.assetTag}
                    </Typography>

                    <Typography paragraph>Serial Number:</Typography>
                    <Typography paragraph>
                        {item.serialNo}
                    </Typography>
                    <div>
                      <Button variant="outlined" color="primary" fullWidth onClick={()=>cancelItem(item)}>Cancel Processing</Button>
                    </div>
                  </CardContent>
                </Collapse>
          </Card>
          </Grid>
          )
        }
      })
    }
    </Grid>
    </React.Fragment>
  );
}

export default ForProcessing
